<template>
  <div>
    <div class="header"><h1>Login</h1></div>
    <div class="content">
      <p>Log in to fill your shelves</p>
      <p>
        <a class="twitter-before"><i class="fab fa-twitter"></i></a>
        <a class="twitter pure-button" href="/login/twitter"
          >Login Using Twitter</a
        >
      </p>
      <p>
        <a class="facebook-before"><i class="fab fa-facebook"></i></a>
        <a class="facebook pure-button" href="/login/facebook"
          >Login Using Facebook</a
        >
      </p>
    </div>
  </div>
</template>
<style>
.twitter-before,
.facebook-before {
  background-color: #189bcb;
  border-radius: 3px 0px 0px 3px;
  color: #f4f4f4;
  display: block;
  float: left;
  height: 50px;
  line-height: 50px;
  text-align: center;
  width: 50px;
}
.twitter,
.facebook {
  background-color: #1bb2e9;
  border: none;
  border-radius: 0px 3px 3px 0px;
  color: #f4f4f4;
  cursor: pointer;
  height: 50px;
  text-transform: uppercase;
  width: 250px;
  line-height: 35px;
}
</style>
<script>
export default {
  methods: {
    login() {
      this.$router.go('/login/twitter');
    },
  },
};
</script>
